// System (desktop) notifications: shown by Windows/macOS with the system
// sound even when the browser is minimised or another app is in front, and
// not subject to the "click the page first" rule for in-page sound. The
// browser's permission is asked only from our own card
// (components/DesktopAlertsPrompt.js), never automatically. Best-effort:
// unsupported or blocked means nothing happens.

export function desktopNotifySupported() {
  return typeof window !== "undefined" && "Notification" in window && window.isSecureContext;
}

export function showDesktopNotification({ title, body, tag, onClick }) {
  if (!desktopNotifySupported() || Notification.permission !== "granted") return null;
  try {
    const n = new Notification(title, { body, tag, requireInteraction: true });
    n.onclick = () => {
      window.focus();
      n.close();
      if (onClick) onClick();
    };
    return n;
  } catch (e) {
    return null;
  }
}
